import { render, staticRenderFns } from "./GridLayoutConfig.vue?vue&type=template&id=8ef9b6ee&"
import script from "./GridLayoutConfig.vue?vue&type=script&lang=js&"
export * from "./GridLayoutConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports